
import React from 'react';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';

import Text from '../../common/client/components/Text';

const classNames = mergeStyleSets({
    root: {
    }
});

const ObjectInfoLoading = (props) => {
    return (
        <div className={classNames.root}>
            <Text>Načítám informace...</Text>
        </div>
    );
}

export default ObjectInfoLoading;
